import { render, staticRenderFns } from "./SupplierBottom.vue?vue&type=template&id=53cad7f8"
import script from "./SupplierBottom.vue?vue&type=script&lang=js"
export * from "./SupplierBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports